import './auto-complete-text-field2-modal.scss'

import { defineComponent, PropType } from 'vue';
import { BModal } from 'bootstrap-vue';
import { faCheck } from '@fortawesome/free-solid-svg-icons'

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { FIELD_VALUE_UPDATED } from '../../events';

export const AutoCompleteTextField2Modal = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        availableValues: {
            type: Array as PropType<String[]>,
            default: () => [],
        },
        value: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        title: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        primaryColor: {
            type: Boolean,
            default: false,
        },
        xxl: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./auto-complete-text-field2-modal.html'),
    data() {
        return {
            checkIcon: faCheck,
        }
    },
    computed: {
        valueCopy: {
            get(): String {
                return this.value ?? ""
            },
            set(newValue: String) {
                this.$emit(FIELD_VALUE_UPDATED, newValue)
            },
        },
        filteredSuggestions(): String[] {
            return this.availableValues.filter(value => {
                return value.includes(this.valueCopy as string) && value != this.valueCopy
            })
        },
    },
    methods: {
        onSuggestionClicked(value: string) {
            this.valueCopy = value
            setTimeout(
                () => {
                    (this.$refs.modal as BModal).hide()
                },
                200
            )
        },
        closeModal() {
            (this.$refs.modal as BModal).hide()
        },
        openModal() {
            (this.$refs.modal as BModal).show()
        },
    },
})
